
import { defineComponent, PropType } from "vue";
import { IDanhMucToaXeResponseBase } from "@/core/interfaces/ApiResponses";
import { useRouterCustom } from "@/core/hooks/use-router-custom";
import { withListPage } from "@/core/helpers/list-page-context";
import { swalErrNotification, swalNotification } from "@/core/helpers/utils";
import { usePagination } from "@/core/hooks/use-pagination";

import Setting from "@/components/shared/setting/Setting.vue";
import type { SettingAction } from "@/components/shared/setting/Setting.vue";
import DanhMucToaXeService from "@/core/services/DanhMucToaXe.service";
import ConfirmationDialog from "@/components/confirmation-dialog/ConfirmationDialog.vue";
import useDanhMucToaXe from "@/core/hooks/use-danh-muc-toa-xe";
import IconEye from "@/icons/IconEye.vue";
import IconPencil from "@/icons/IconPencil.vue";
import IconTrash from "../../../../../icons/IconTrash.vue";

export default defineComponent({
  name: "danh-muc-toa-xe-table",

  components: { ConfirmationDialog, Setting },

  emits: ["delete-danh-muc-toa-xe-success"],

  setup() {
    const { push } = useRouterCustom();

    const { indexCal } = usePagination();

    const { isTextDangerColumn } = useDanhMucToaXe();

    return {
      indexCal,
      push,
      isTextDangerColumn,
    };
  },

  props: {
    curPage: {
      type: Number,
      default: 0,
    },
    items: {
      type: Array as PropType<Array<IDanhMucToaXeResponseBase>>,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    showNhomCha: {
      type: Boolean,
      default: false,
    },
    perPage: {
      type: Number,
      default: 0,
    },
    /** When set (update page), highlight the row for the item being edited */
    selectedId: {
      type: Number,
      default: 0,
    },
  },

  data: () => ({
    isDeletingModalDisplay: false,
    deletingDanhMucToaXe: null as IDanhMucToaXeResponseBase | null,
  }),

  methods: {
    rowClassName({ row }: { row: IDanhMucToaXeResponseBase }): string {
      if (this.selectedId > 0 && row.id === this.selectedId) {
        return "current-row";
      }

      return "";
    },

    getSettingActions(row: IDanhMucToaXeResponseBase): SettingAction[] {
      return [
        {
          icon: IconEye,
          label: "Chi tiết",
          tooltip: "Chi tiết",
          onClick: () =>
            this.push(`/quan-ly/danh-muc-toa-xe/chi-tiet/${row.id}`),
        },
        {
          icon: IconPencil,
          label: "Chỉnh sửa",
          tooltip: "Chỉnh sửa",
          any: ["master:danhmuctoaxe:sua"],
          onClick: () =>
            this.push(
              withListPage(
                `/quan-ly/danh-muc-toa-xe/cap-nhat/${row.id}`,
                this.curPage
              )
            ),
        },
        {
          icon: IconTrash,
          label: "Xoá",
          any: ["master:danhmuctoaxe:xoa"],
          onClick: () => {
            this.onDeleteButtonClicked(row.id);
          },
        },
      ];
    },

    onDeleteButtonClicked(id: number) {
      this.isDeletingModalDisplay = true;
      const deletingItem = this.items?.find((item) => item.id === id);
      if (deletingItem) {
        this.deletingDanhMucToaXe = deletingItem;
      }
    },

    async confirmDelete() {
      this.isDeletingModalDisplay = false;
      try {
        if (this.deletingDanhMucToaXe) {
          await DanhMucToaXeService.delete(this.deletingDanhMucToaXe?.id);
        }
        await swalNotification("Xóa thành công", "success");
        this.$emit("delete-danh-muc-toa-xe-success");
      } catch (error) {
        await swalErrNotification(
          error,
          "Có lỗi xảy ra, không thể xóa Nhóm toa xe này"
        );
      }
    },
  },
});
